export enum Relationship {
    MYSELF = 'Myself',
    EMPLOYEE = 'Employee',
    FAMILY_MEMBER = 'Family member',
    COVERED_DEPENDENT = 'Covered dependent'
}